import React, { useId } from 'react';
import {
  Select,
  MenuItem,
  SelectChangeEvent,
  FormControl,
  InputLabel
} from '@mui/material';
import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';

interface OperationsSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  label?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
}

const OperationsSelect: React.FC<OperationsSelectProps> = ({
  value,
  onChange,
  options,
  label,
  fullWidth = true,
  size = 'small'
}) => {
  const labelId = useId();

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  const handleClose = () => {
    // Blur when dropdown closes (including when clicking elsewhere or selecting an item)
    setTimeout(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    }, 0);
  };

  return (
    <FormControl fullWidth={fullWidth} size={size}>
      {label &&
        <InputLabel id={labelId}>
          {label}
        </InputLabel>
      }
      <Select
        value={value}
        onChange={handleChange}
        onClose={handleClose}
        IconComponent={ArrowDropDownIcon}
        labelId={labelId}
        label={label}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OperationsSelect;
